import { render, staticRenderFns } from "./AddNewProductPopup.vue?vue&type=template&id=2de1374c&scoped=true"
import script from "./AddNewProductPopup.vue?vue&type=script&lang=js"
export * from "./AddNewProductPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de1374c",
  null
  
)

export default component.exports